import {AddressRestDto} from "@/api/pharma-order-settings/models";

export class AddressRestDtoModel implements AddressRestDto {
    street?: string|null;
    extra_address_line?: string|null;
    house_number?: string|null;
    box?: string|null;
    postal_code?: string|null;
    postal_code_addition?: string|null;
    city_name?: string|null;
    country_name?: string|null;

    constructor() {
    }

    public static createWithDefaults(): AddressRestDtoModel {
        return new AddressRestDtoModel();
    }
}
